/** Supervisor nav + home — only this role */
export const SUPERVISOR_ROLES = ['supervisor'];

/** Department → employees.role (saved automatically from department) */
export const DEPT_TO_ROLE = {
  ADMIN: 'admin',
  FLEET: 'fleet_operator',
  SHOP: 'mechanic',
  WELDERS: 'welders',
};

export function roleFromDeptCode(deptCode) {
  const code = (deptCode || 'SHOP').toUpperCase();
  return DEPT_TO_ROLE[code] || 'mechanic';
}

export function isSupervisorRole(role) {
  return SUPERVISOR_ROLES.includes(String(role || '').toLowerCase());
}

export function homePathForRole(role) {
  return isSupervisorRole(role) ? '/all-timesheets' : '/my-timesheet';
}
